<div class="bg-white p-1 p-md-4 payment-info">
    <div class="text-center mt-4">
        <img src="/img/OK.png" alt="" style="max-width: 40%" class="img-fluid img-cover" />
    </div>
    <h3 class="text-center font-weight-bold mt-4">
        <span [innerHTML]="'web.payment_success' | translate | markdown" class="emph-text-dashboard"></span>
    </h3>
    <div class="text-center mt-5">
        {{ 'web.payment_success_text' | translate }}
    </div>
    <div class="text-center mt-5">
        <a [routerLink]="['/page/account/dashboard']" class="--button">{{
            'web.payment_success_get_edge' | translate
        }}</a>
    </div>
</div>
